/**
 * Packages & Services — per-service deliverables editor. Originally
 * extracted in Task 150-A; re-introduced in Task 151-B inside the
 * package drawer's "advanced terms" section so deliverables remain
 * editable per included service. Behavior unchanged from the 150-A
 * version.
 */

import type { PackageServiceDeliverable, ServiceCadence } from '../../api/types';
import { DELIVERABLE_TYPE_OPTIONS, SERVICE_CADENCES } from './constants';

export function DeliverablesEditor({
  deliverables,
  submitting,
  onChange,
}: {
  readonly deliverables: ReadonlyArray<PackageServiceDeliverable>;
  readonly submitting: boolean;
  readonly onChange: (next: ReadonlyArray<PackageServiceDeliverable>) => void;
}) {
  function add() {
    onChange([
      ...deliverables,
      { type: 'design', label: '', quantity: null, cadence: 'monthly', notes: null },
    ]);
  }
  function update(i: number, partial: Partial<PackageServiceDeliverable>) {
    onChange(deliverables.map((d, idx) => (idx === i ? { ...d, ...partial } : d)));
  }
  function remove(i: number) {
    onChange(deliverables.filter((_, idx) => idx !== i));
  }
  return (
    <div style={{ marginTop: 10 }}>
      <div className="lbl" style={{ marginBottom: 6, fontSize: 11 }}>
        التسليمات (اختياري) — مثل: ٦ منشورات شهرياً، ١٥ تصميماً، تقرير شهري…
      </div>
      {deliverables.length > 0 ? (
        <ul
          style={{
            listStyle: 'none',
            padding: 0,
            margin: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: 6,
          }}
        >
          {deliverables.map((d, i) => (
            <li
              key={i}
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit,minmax(120px,1fr)) auto',
                gap: 6,
                padding: '6px 8px',
                background: 'var(--cream-2)',
                borderRadius: 'var(--r-sm)',
              }}
            >
              <select
                className="auth-input"
                value={d.type}
                onChange={(e) =>
                  update(i, { type: e.currentTarget.value as PackageServiceDeliverable['type'] })
                }
                disabled={submitting}
                style={{ paddingInlineStart: 12, fontSize: 12 }}
              >
                {DELIVERABLE_TYPE_OPTIONS.map((o) => (
                  <option key={o.value} value={o.value}>
                    {o.label}
                  </option>
                ))}
              </select>
              <input
                className="auth-input"
                value={d.label}
                onChange={(e) => update(i, { label: e.currentTarget.value })}
                placeholder="الاسم"
                maxLength={200}
                disabled={submitting}
                style={{ paddingInlineStart: 12, fontSize: 12 }}
              />
              <input
                className="auth-input"
                value={d.quantity !== null ? String(d.quantity) : ''}
                onChange={(e) =>
                  update(i, {
                    quantity:
                      e.currentTarget.value.trim().length === 0
                        ? null
                        : Number(e.currentTarget.value) || null,
                  })
                }
                placeholder="الكمية"
                type="number"
                disabled={submitting}
                dir="ltr"
                style={{ paddingInlineStart: 12, fontSize: 12 }}
              />
              <select
                className="auth-input"
                value={d.cadence ?? ''}
                onChange={(e) =>
                  update(i, {
                    cadence: (e.currentTarget.value === ''
                      ? null
                      : e.currentTarget.value) as ServiceCadence | null,
                  })
                }
                disabled={submitting}
                style={{ paddingInlineStart: 12, fontSize: 12 }}
              >
                {SERVICE_CADENCES.map((c) => (
                  <option key={c.value} value={c.value}>
                    {c.label}
                  </option>
                ))}
              </select>
              <button
                type="button"
                className="btn-text"
                onClick={() => remove(i)}
                disabled={submitting}
                style={{ padding: '4px 8px', fontSize: 11, color: 'var(--rose)' }}
              >
                حذف
              </button>
            </li>
          ))}
        </ul>
      ) : null}
      <button
        type="button"
        className="btn-text"
        onClick={add}
        disabled={submitting}
        style={{ padding: '6px 10px', fontSize: 12, marginTop: 6 }}
      >
        + إضافة تسليم
      </button>
    </div>
  );
}
